/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Limit order request
 */
export interface LimitOrderRequest {
  /**
   * Account ID.
   */
  accountId: number;
  /**
   * Trade direction.
   */
  side: LimitOrderRequest.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  units: number;
  /**
   * Base pair ID.
   */
  basePairId: number;
  /**
   * Limit price.
   */
  limitPrice: number;
  /**
   * Time in force.
   */
  timeInForce: LimitOrderRequest.TimeInForceEnum;
}
export namespace LimitOrderRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const TimeInForceEnum = {
    Ioc: 'IOC',
    Gtc: 'GTC',
  } as const;
  export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];
}
